<template>
  <sh-button
    :[btnLinkKey]="href"
    :[setStyle]="true"
    :size="size"
    :color="setColor"
    :target="target"
  >
    {{ text }}
  </sh-button>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CTA from '~/constants/appearance'
import { getButtonType } from '~/helpers/get-button-type'
import get from '~/helpers/get'
import getButtonColor from '~/helpers/get-button-color'
import getButtonStyle from '~/helpers/get-button-style'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'CTA',
  props: {
    ctaFields: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: String,
      default: 'medium'
    },
    ctaAppearance: {
      type: String,
      default: CTA.DARK_BLOCK
    }
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['isDarkTheme']),
    text () {
      return get(this.ctaFields, 'text')
    },
    href () {
      return get(this.ctaFields, 'href')
    },
    target () {
      return get(this.ctaFields, 'target')
    },
    color () {
      return getButtonColor(this.setCtaAppearance)
    },
    setStyle () {
      return getButtonStyle(this.setCtaAppearance)
    },
    setColor () {
      if (this.isDarkTheme && this.$device.isMobile) return CTA.SECONDARY
      if (!this.isDarkTheme && this.$device.isMobile) return CTA.PRIMARY
      return this.color
    },
    setCtaAppearance () {
      if (this.$device.isMobile) {
        if (this.isDarkTheme && this.ctaAppearance === CTA.DARK_LINK) return CTA.LIGHT_OUTLINE
        if (!this.isDarkTheme && this.ctaAppearance === CTA.LIGHT_LINK) return CTA.DARK_OUTLINE
      }
      return this.ctaAppearance
    },
    btnLinkKey () {
      if (!this.ctaFields) return ''
      return getButtonType(this.href)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
